module.exports = __webpack_public_path__ + "img/atalho-1.d6d44e3f.png";